import { IntlShape } from 'react-intl';
import { find } from 'lodash';

import { langMessages } from '@app/translations';

import { MappedFacetValue, UnmappedFacetValue } from '../constants';
import languages from '../languages.json';

// Given a two or three-character language code, return a localized language name string
export const formatLanguageName = (
  code: string,
  $t: IntlShape['$t']
): string => {
  const language = find(
    languages,
    entry =>
      entry.alpha3 === code.toLowerCase() || entry.alpha2 === code.toLowerCase()
  );

  if (language === undefined) {
    return $t(langMessages.undefined);
  }

  if (langMessages[language.alpha3]) {
    return $t(langMessages[language.alpha3]);
  }

  return language.name;
};

export const getLanguageOptions = (
  $t: IntlShape['$t'],
  langs: UnmappedFacetValue[] = []
): MappedFacetValue[] =>
  langs.map(({ id, totalRecords }) => ({
    label: formatLanguageName(id, $t),
    value: id,
    count: totalRecords,
    id,
  }));
